var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"customer-footer-bar"},[(!_vm.is_manager)?_c('CustomerFooterBar'):_c('ManageFooterBar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }